var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngineeringHelmetCogSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#9199A3;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#9199A3;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#9199A3;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,13l-2-9l0,0c3.8-1.9,8.2-1.9,12,0l0,0l-2,9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,5.6C24.9,7.5,27,11,27,15v2l2,2H16H3l2-2v-2c0-4,2.1-7.5,5.3-9.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,19.1c-0.1,0.6-0.2,1.3-0.2,1.9c0,0.7,0.1,1.3,0.2,1.9c1-0.1,2,0.3,2.5,1.3c0.5,0.9,0.4,2-0.2,2.8 c0.9,0.9,2.1,1.6,3.4,2c0.4-0.9,1.3-1.6,2.4-1.6s2,0.7,2.4,1.6c1.3-0.4,2.4-1.1,3.4-2c-0.6-0.8-0.7-1.9-0.2-2.8 c0.5-0.9,1.6-1.4,2.5-1.3c0.1-0.6,0.2-1.3,0.2-1.9c0-0.7-0.1-1.3-0.2-1.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,19c-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineeringHelmetCogSvgrepoCom);
export default __webpack_public_path__ + "static/media/engineering-helmet-cog-svgrepo-com.1ba356d0efe044596b0ea2e4c445d52f.svg";
export { ForwardRef as ReactComponent };